import { SET_LOADING_STATUS } from '../utils/type';

const initialState = {
  isLoading: false
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING_STATUS:
      return {
        ...state,
        isLoading: action.data
      };
    default:
      return state;
  }
};

export default loaderReducer;
